import React, { useEffect } from 'react';
import { Box, Title, View } from '@common/components';
import { connect } from 'react-redux';
import { setNavigation } from '@resources/Navigation/actions';
import { Button, Space, Table, Modal } from 'antd';
import {
  deleteTeam,
  clearTeams,
  fetchTeamsByGame,
} from '@resources/Team/actions';
import { addClue } from '@resources/Clue/actions';
import { doAction } from '@resources/Action/actions';
import { updateMember } from '@resources/Member/actions';
import { addSolve } from '@resources/Solve/actions';
import { addStory } from '@resources/Story/actions';

const Manage = ({
  teams,
  match,
  history,
  clearTeams,
  fetchTeamsByGame,
  deleteTeam,
}) => {
  const { params } = match || {};
  const { gameId } = params;

  const fetchData = async () => {
    await clearTeams();
    await fetchTeamsByGame(gameId);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text) => text,
    },

    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <Space size="middle">
          <Button
            size="small"
            onClick={() => {
              history.push(`/carnival/${gameId}/teams/${record._id}`);
            }}
          >
            Edit
          </Button>
          <Button
            size="small"
            type="danger"
            onClick={async () => {
              Modal.confirm({
                title: 'Delete Team',
                content: 'Are you sure you want to delete this team?',
                onOk: async () => {
                  await deleteTeam(record._id);
                  fetchData();
                },
              });
            }}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <View>
      <Box pt={100} px={30} mb={100}>
        <Title>Teams - {gameId}</Title>
        <Button onClick={() => history.push(`/carnival/${gameId}/game-master`)}>
          Back to Game
        </Button>
        &nbsp;&nbsp;
        <Button
          onClick={() => history.push(`/carnival/${gameId}/teams`)}
          type="primary"
        >
          + Add Team
        </Button>
        <Table columns={columns} dataSource={teams} />
      </Box>
    </View>
  );
};

const mapStateToProps = (state) => ({
  teams: state.teams,
  socket: state.socket,
  clues: state.clues,
  solves: state.solves,
  puzzle: state.puzzle,
});

export default connect(mapStateToProps, {
  doAction,
  addClue,
  setNavigation,
  updateMember,
  addSolve,
  addStory,
  clearTeams,
  fetchTeamsByGame,
  deleteTeam,
})(Manage);
